import type { ReactElement } from 'react';
import Markdown from 'react-markdown';
import type { Options } from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

/**
 * `~` strikes through only as `~~` — the rule the editor parses by
 * (`lib/note-markdown.ts`). With GFM's single tilde, "~$12 a seat (~$100 a
 * year)" struck through everything between the two estimates.
 */
const GFM: Options['remarkPlugins'] = [[remarkGfm, { singleTilde: false }]];

/** Every line break kept, for what was typed line by line and is shown as typed. */
const AS_TYPED: Options['remarkPlugins'] = [[remarkGfm, { singleTilde: false }], remarkBreaks];

/**
 * Markdown a person reads and does not edit: a note, a write-up, a discussion.
 * `breaks` for what somebody typed, where a new line is a new line.
 */
export function NoteText({
  children,
  breaks = false,
}: {
  children: string;
  breaks?: boolean;
}): ReactElement {
  return <Markdown remarkPlugins={breaks ? AS_TYPED : GFM}>{children}</Markdown>;
}
